import { createDerivedWritableAtom } from '../../utils';
import { videoSDKAtom } from '../core/atoms';

export const zoomTokenAtom = createDerivedWritableAtom(videoSDKAtom, 'zoomToken');
